type KeywordMatcher = (phrase?: string) => boolean;

// Compiles the pattern once so callers can test every event without
// rebuilding it.
export function createKeywordMatcher(keywords: string[]): KeywordMatcher {
  const escaped = keywords.map((keyword) =>
    keyword.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
  );
  const pattern = escaped.length
    ? new RegExp(escaped.join('|'), 'i')
    : undefined;

  return (phrase?: string) => {
    if (!pattern || !phrase) {
      return false;
    }

    return pattern.test(phrase);
  };
}
